import React, { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name.split(" ")[0]}`);
      navigate(loc.state?.from || (u.role === "admin" ? "/admin" : "/account"));
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="login-page">
      <div className="label-mono text-cyan-400 mb-3">/ AUTH</div>
      <h1 className="text-4xl font-medium tracking-tight">Sign in</h1>
      <form onSubmit={submit} className="mt-8 space-y-4">
        <label className="block">
          <span className="label-mono text-slate-500">Email</span>
          <input data-testid="login-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                 className="mt-1.5 w-full bg-transparent border border-white/10 focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500/30 outline-none px-3 h-11" />
        </label>
        <label className="block">
          <span className="label-mono text-slate-500">Password</span>
          <input data-testid="login-password" required type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                 className="mt-1.5 w-full bg-transparent border border-white/10 focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500/30 outline-none px-3 h-11" />
        </label>
        <button data-testid="login-submit" disabled={busy} type="submit" className="w-full bg-cyan-500 hover:bg-cyan-400 disabled:bg-slate-700 text-slate-950 font-semibold py-3">
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
      <p className="mt-6 text-sm text-slate-400">
        No account? <Link to="/register" className="text-cyan-400 hover:text-cyan-300">Create one</Link>
      </p>
    </div>
  );
}
